// hooks/useUndoRedo.ts
import { useState } from "react";

export function useUndoRedo<T>(initialValue: T) {
	const [value, setValue] = useState<T>(initialValue);
	const [undoStack, setUndoStack] = useState<T[]>([]);
	const [redoStack, setRedoStack] = useState<T[]>([]);

	const set = (newValue: T | ((prev: T) => T)) => {
		setUndoStack((prev) => [...prev, value]);

		const updatedValue =
			typeof newValue === "function" ? (newValue as (prev: T) => T)(value) : newValue;

		setValue(updatedValue);
		setRedoStack([]);
	};

	const undo = () => {
		if (undoStack.length === 0) {
			return;
		}

		const prev = undoStack[undoStack.length - 1];

		setUndoStack((stack) => stack.slice(0, -1));
		setRedoStack((stack) => [...stack, value]);
		setValue(prev);
	};

	const redo = () => {
		if (redoStack.length === 0) {
			return;
		}

		const next = redoStack[redoStack.length - 1];

		setRedoStack((stack) => stack.slice(0, -1));
		setUndoStack((stack) => [...stack, value]);
		setValue(next);
	};

	const canUndo = undoStack.length > 0;
	const canRedo = redoStack.length > 0;

	return { value, set, undo, redo, canUndo, canRedo };
}
